import React from 'react';

import { Redirect, Route, Router, Switch } from 'wouter';

import PhoneVerificationPage from '../phone_verification/PhoneVerificationPage';
import AuthLayout from './AuthLayout';
import AuthPage from './AuthPage';

function normalizedPathPrefix(pathPrefix) {
  if (!pathPrefix) return '';
  const normalized = pathPrefix.startsWith('/') ? pathPrefix : `/${pathPrefix}`;

  return normalized.endsWith('/') ? normalized.slice(0, -1) : normalized;
}

export default function AuthApp({
  pathPrefix,
  phoneConfirmation,
  phoneDisplay,
  phoneMergeConfirmation,
  phoneResendCooldown,
  phoneSkippable,
  privacyUrl,
  signupInvitationEmail,
  signupInvitationMode,
  signupInvitationRequired,
  successUrl,
  termsUrl,
}) {
  return (
    <AuthLayout privacyUrl={privacyUrl} termsUrl={termsUrl}>
      <Router base={normalizedPathPrefix(pathPrefix)}>
        <Switch>
          <Route path="/login">
            <AuthPage
              key="login"
              initialSignupInvitationEmail={signupInvitationEmail}
              initialSignupInvitationMode={signupInvitationMode}
              initialSignupInvitationRequired={signupInvitationRequired}
              pageKey="login"
              successUrl={successUrl}
            />
          </Route>
          <Route path="/phone/verify">
            <PhoneVerificationPage
              initialConfirmation={phoneConfirmation}
              initialMergeConfirmation={phoneMergeConfirmation}
              initialPhoneDisplay={phoneDisplay}
              initialResendCooldown={phoneResendCooldown}
              skippable={phoneSkippable}
            />
          </Route>
          <Redirect to="/login" />
        </Switch>
      </Router>
    </AuthLayout>
  );
}
